module.exports = __webpack_public_path__ + "static/media/remove-button.3e6962dd.svg";